import "./PaymentTypeSelectionSubform.scss";

import { Grid, Typography } from "@material-ui/core";
import { CommonValueOutput } from "common/components/CommonValueOutput";
import { InvestmentField, InvestmentInputTypeKey } from "common/components/input/fields";
import { SubformProps } from "common/components/SubformProps";
import { CreateInvestmentManageable } from "common/store/investment/types";
import React from "react";
import { useTranslation } from "react-i18next";

export const PaymentTypeSelectionSubform = (props: SubformProps<CreateInvestmentManageable>) => {
  const { t } = useTranslation();

  return (
    <Grid item container direction="column" spacing={4}>
      <Grid item xs={12}>
        <Typography variant="body1" color="textSecondary">
          {t("Wire transfer authorization")}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1" color="textSecondary">
          {t("The investment amount will be debited from your current account after verification and acceptance of the subscription by the issuer of the investment. Please grant us a direct debit authorization for this purpose. The account must be in your name.")}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <InvestmentField
          id={"paymentMethodType" as InvestmentInputTypeKey}
          {...props}
        />

        {props.values.paymentMethodType &&
        <>
          <Typography className="bold" variant="body1" color="textSecondary">
            {t("Recipient FinPro AG   |   Bank The Deutche Bank")}
          </Typography>

          <Typography className="bold" variant="body1" color="textSecondary">
            {t("Account No. 02100002156577734   |   Routing No. 262654")}
          </Typography>
        </>
        }
      </Grid>

      <Grid item md={4} sm={6} xs={12}>
        <CommonValueOutput
          label={t("Total amount")}
          value={`€ ${props.values.amountShares}`}
        />
      </Grid>
    </Grid>
  );
};
